module.exports = __webpack_public_path__ + "static/img/q-pattern.d6804e6b.png";